(function () {

  function initTracker(root) {
    const jsonEl = root.querySelector('[data-variant-inventory]');
    if (!jsonEl) return;

    const data = JSON.parse(jsonEl.textContent);
    const textEl = root.querySelector('[data-inventory-text]');

    const lowThreshold = 20;      // Under 20 = Red
    const mediumThreshold = 100;  // 100+ = Green

    function setStatus(text, color) {
      textEl.textContent = text;
      textEl.style.color = color;
      textEl.style.fontWeight = "600";
    }

    function render(variantId) {
      const v = data.variants.find(x => String(x.id) === String(variantId));
      if (!v) return;

      const qty = Number(v.inventory_quantity || 0);

      // OUT OF STOCK
      if (!v.available || qty <= 0) {
        setStatus("Sold out — restocking soon", "#6c757d");
        return;
      }

      // LOW STOCK (RED)
      if (qty < lowThreshold) {
        setStatus(`Almost gone — only ${qty} left`, "#d62828");
        return;
      }

      // MEDIUM STOCK (YELLOW)
      if (qty < mediumThreshold) {
        setStatus(`${qty} available — popular right now`, "#f9a825");
        return;
      }

      // HIGH STOCK (GREEN)
      setStatus("In stock — ready to ship", "#2e7d32");
    }

    const scope = root.closest('product-info, .product') || document;
    const idInput = scope.querySelector('input[name="id"]') || document.querySelector('input[name="id"]');

    if (idInput) render(idInput.value);

    document.addEventListener('change', (e) => {
      if (e.target && (e.target.closest('variant-selects') || e.target.closest('variant-radios'))) {
        const now = (scope.querySelector('input[name="id"]') || document.querySelector('input[name="id"]'))?.value;
        if (now) render(now);
      }
    });

    if (idInput) {
      let last = idInput.value;
      setInterval(() => {
        if (idInput.value !== last) {
          last = idInput.value;
          render(last);
        }
      }, 300);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-inventory-tracker]').forEach(initTracker);
  });

})();